<div class="relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog" aria-modal="true">

    <div class="absolute inset-0 z-10 overflow-hidden green-noise-bg flex items-center justify-center">

        <button type="button" (click)="closeHelp()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
        </button>


        <div class="relative w-[70%] h-[70%] primary-card-container flex flex-col overflow-hidden p-2 gap-y-2">
            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <div class="relative z-10 h-full w-full p-6 sm:p-8 overflow-y-auto scrollbar-transparent">
                <div class="w-full">
                    <div class="flex items-center gap-x-3">
                        <div
                            class="size-10 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"
                                class="size-5 text-accent/90">
                                <path d="M4 7h16" />
                                <path d="M4 12h16" />
                                <path d="M4 17h10" />
                            </svg>
                        </div>
                        <h2 class="text-xl sm:text-2xl font-semibold text-primary">What is creator screening?</h2>
                    </div>

                    <p class="mt-4 text-sm sm:text-base text-secondary">
                        Creator screening is a structured review process to make sure the right social media creators
                        join a brief. It combines eligibility checks, content fit, and quality signals so brands can
                        confidently pick creators who align with the campaign goals.
                    </p>

                    <div class="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div
                            class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                            <h3 class="text-sm font-semibold text-primary">What we evaluate</h3>
                            <ul class="mt-3 space-y-2 text-sm text-secondary">
                                <li class="flex gap-x-2">
                                    <span class="mt-1 size-1.5 rounded-full bg-primary"></span>
                                    Audience relevance and location fit
                                </li>
                                <li class="flex gap-x-2">
                                    <span class="mt-1 size-1.5 rounded-full bg-primary"></span>
                                    Content quality and brand safety
                                </li>
                                <li class="flex gap-x-2">
                                    <span class="mt-1 size-1.5 rounded-full bg-primary"></span>
                                    Past performance and consistency
                                </li>
                            </ul>
                        </div>

                        <div
                            class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                            <h3 class="text-sm font-semibold text-primary">Why it matters</h3>
                            <ul class="mt-3 space-y-2 text-sm text-secondary">
                                <li class="flex gap-x-2">
                                    <span class="mt-1 size-1.5 rounded-full bg-emerald-500"></span>
                                    Higher-quality submissions and fewer revisions
                                </li>
                                <li class="flex gap-x-2">
                                    <span class="mt-1 size-1.5 rounded-full bg-emerald-500"></span>
                                    Better alignment with campaign goals
                                </li>
                                <li class="flex gap-x-2">
                                    <span class="mt-1 size-1.5 rounded-full bg-emerald-500"></span>
                                    Safer, more consistent brand representation
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div
                        class="mt-6 rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                        <h3 class="text-sm font-semibold text-primary">Who can I screen?</h3>
                        <ul class="mt-3 space-y-2 text-sm text-secondary">
                            <li class="flex gap-x-2">
                                <span class="mt-1 size-1.5 rounded-full bg-yellow-500"></span>
                                Any creators found on SHOUT
                            </li>
                            <li class="flex gap-x-2">
                                <span class="mt-1 size-1.5 rounded-full bg-yellow-500"></span>
                                Any creators on TikTok or Instagram. (Upload a spreadsheet of creators that you want to screen)
                            </li>
                        </ul>
                    </div>

                    <div class="mt-6 rounded-lg bg-primary/10 dark:bg-primary/15 p-4">
                        <p class="text-sm text-secondary">
                            If you want to check months or years of previous content this is the option you require.
                            Simply select the creators and applicable accounts you wish to evaluate and SHOUT will
                            screen all content
                            against your requirements. Create a <i>Screening Brief</i> to set rules and requirements for
                            the screening.
                        </p>
                    </div>

                    <div class="mt-6 rounded-lg bg-primary/10 dark:bg-primary/10 p-4">
                        <p class="text-sm text-secondary">
                            Tip: If a creator doesn’t pass screening, they can still improve by updating their profile,
                            refining their content examples, and aligning to the brief requirements.
                        </p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>